import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import AccountCreation from './pages/account-creation';
import ExpansionProgression from './pages/expansion-progression';
import MemberDirectory from './pages/member-directory';
import GuildDashboard from './pages/guild-dashboard';
import CharacterManagement from './pages/character-management';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<GuildDashboard />} />
        <Route path="/account-creation" element={<AccountCreation />} />
        <Route path="/expansion-progression" element={<ExpansionProgression />} />
        <Route path="/member-directory" element={<MemberDirectory />} />
        <Route path="/guild-dashboard" element={<GuildDashboard />} />
        <Route path="/character-management" element={<CharacterManagement />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
